import {
  VALIDATE_QUIZ_REQUEST,
  VALIDATE_QUIZ_SUCCESS,
  VALIDATE_QUIZ_FAILURE,
  RESET_QUIZ_RESULT 
} from '../../../Constants/actionTypes'

import { API_LEARNING_HUN_QUIZ_VERIFY } from '../../../Constants/apiUrls'

// Helper function to handle errors
const handleErrors = async (response) => {
  if (!response.ok) {
      const errorText = await response.text();
      try {
          const errorJson = JSON.parse(errorText);
          return errorJson.error || 'Unknown Error'; // Return the error message
      } catch (e) {
          return errorText || 'Unknown Error'; // Return the error text if JSON parsing fails
      }
  }
  return null; // No error
};


export const resetQuizResult = () => ({
    type: RESET_QUIZ_RESULT,
  });


export const validateQuiz = (certName, answers, id) => {
 // console.log(answers)
  return async (dispatch, getState) => {
      dispatch({ type: VALIDATE_QUIZ_REQUEST });
      try {
        const state = getState();
        const accessToken = state.auth.accessToken; 

          const response = await fetch(API_LEARNING_HUN_QUIZ_VERIFY(id), {
              method: 'POST',
              headers: {
                  'Content-Type': 'application/json',
                  'Authorization': `Bearer ${accessToken}`, 
              },
              body: JSON.stringify({ answers }),
          });
          const errorMessage = await handleErrors(response); 
          if (errorMessage) {
              throw new Error(errorMessage); 
          }
          const data = await response.json();
          console.log(data)
          dispatch({
              type: VALIDATE_QUIZ_SUCCESS,
              payload: data,
          });
      } catch (error) {
        let errorMessage;
            if (error.message === 'Failed to fetch' || error.message.includes('NetworkError')) {
                errorMessage = 'Server is currently down. Please try again later.';
            } else {
                errorMessage = error.message;
            }
          dispatch({
              type: VALIDATE_QUIZ_FAILURE,
              payload: errorMessage,
          });
      }
  };
};
